module.exports = __webpack_public_path__ + "static/media/blind_code.08b49eb0.png";